<template>
    <div>
        <g-table
            index="ID"
            :limit="12"
            :columns="columns"
            :data="data"
            :loading="loading"
            :disable="end"
            :select.sync="select"
            pagination="loadmore"
            @list="list"
        >
            <template slot="avatar" slot-scope="user">
                <a-avatar :src="$gestios.avatars(user.ID)" />
            </template>

            <template slot="group" slot-scope="item">
                <div v-if="item.BOT === '1'">
                    <a-tag :color="$colors['gray-6']" :class="$style.badgeGroup">
                        <fa-icon icon="robot" class="mr-2" /> Bot
                    </a-tag>
                </div>

                <div v-else-if="item.BOSS === '1'">
                    <a-tag :color="$colors.danger" :class="$style.badgeGroup">
                        <fa-icon icon="chess-king" class="mr-2" /> Admin
                    </a-tag>
                </div>

                <div v-else-if="item.Group.ID !== null">
                    <a-tag :color="$colors.primary" :class="$style.badgeGroup">
                        <fa-icon icon="user" class="mr-2" /> {{ item.Group.Name }}
                    </a-tag>
                </div>

                <div v-else>Ninguno</div>
            </template>

            <template slot="status" slot-scope="user">
                <a-dropdown-button
                    :trigger="['click']"
                    :type="user.Status === '0' ? 'primary' : user.Status === '1' ? 'dashed' : 'danger'"
                >
                    <span>
                        {{ user.Status === '0' ? 'Activo' : user.Status === '1' ? 'Inactivo' : 'Bloqueado' }}
                    </span>

                    <a-menu slot="overlay" @click="userStatus([user], $event.key)">
                        <a-menu-item key="0">
                            <span class="text-primary"
                                ><fa-icon :icon="['fa', 'lock-open']" class="mr-2" /> Activo</span
                            >
                        </a-menu-item>
                        <a-menu-item key="1">
                            <span class="text-warning"><fa-icon :icon="['fa', 'lock']" class="mr-2" /> Inactivo</span>
                        </a-menu-item>
                        <a-menu-item key="2">
                            <span class="text-danger"><fa-icon :icon="['fa', 'lock']" class="mr-2" /> Bloqueado</span>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown-button>
            </template>

            <template slot="actions" slot-scope="user">
                <a-button-group v-if="user.BOT !== '1'">
                    <a-tooltip placement="top">
                        <template slot="title">
                            <span>Editar</span>
                        </template>
                        <a-button @click="$router.push({ name: '_usersForm', params: { id: user.ID } })">
                            <fa-icon :icon="['far', 'edit']" />
                        </a-button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                        <template slot="title">
                            <span>Borrar</span>
                        </template>
                        <a-popconfirm
                            title="¿Estas seguro que deseas borrar este usuario?"
                            @confirm="() => userDelete([user])"
                        >
                            <a-button type="danger">
                                <fa-icon :icon="['far', 'trash-alt']" />
                            </a-button>
                        </a-popconfirm>
                    </a-tooltip>
                </a-button-group>
            </template>

            <template v-if="select.length > 0" slot="head-right">
                <a-tooltip placement="top">
                    <template slot="title">
                        <span>Borrar {{ select.length }} registros</span>
                    </template>
                    <a-popconfirm
                        title="¿Estas seguro que deseas borrar los elementos seleccionados?"
                        @confirm="() => userDelete(select)"
                    >
                        <a-button type="danger">
                            <fa-icon :icon="['far', 'trash-alt']" class="mr-2" /> Borrar
                            <sup class="ml-1 font-weight-bold">({{ select.length }})</sup>
                        </a-button>
                    </a-popconfirm>
                </a-tooltip>
            </template>

            <template slot="_mobile" slot-scope="user">
                <user-card :user="user" @status="userStatus([$event.user], $event.status)" />
            </template>
        </g-table>
    </div>
</template>

<script>
import userCard from './widgets/user-card'

export default {
    name: 'SystemUsers',
    components: {
        userCard,
    },
    data() {
        return {
            loading: false,
            end: false,
            select: [],
            search: 'sassd',
            columns: [
                {
                    title: ' ',
                    index: ' ',
                    slot: 'avatar',
                },
                {
                    title: 'ID',
                    index: 'ID',
                },
                {
                    title: 'Nick',
                    index: 'Nick',
                },
                {
                    title: 'Nombre',
                    index: 'Name',
                },
                {
                    title: 'Email',
                    index: 'Email',
                },
                {
                    title: 'Grupo',
                    index: 'Group',
                    slot: 'group',
                },
                {
                    title: 'Teléfono',
                    index: 'Phone',
                },
                {
                    title: 'Estado',
                    index: '',
                    slot: 'status',
                },
                {
                    title: 'Acciones',
                    index: '',
                    slot: 'actions',
                },
            ],
        }
    },
    computed: {
        data() {
            return this.$gestios.$cache.users
        },
    },
    activated() {
        this.$hub.$on('newUser', () => {
            this.$router.push({ name: '_usersFormAdd' })
        })
    },
    deactivated() {
        this.$hub.$off('newUser')
    },
    methods: {
        // List users
        async list(params) {
            this.loading = true

            const results = await this.$gestios.users.list({
                page: params.page,
                search: params.search,
                limit: params.limit,
                reset: params.reset,
            })

            if (results.code === 404) this.end = true

            this.loading = false
        },
        // Delete user
        userDelete(items) {
            let pass = true
            items.forEach(async (user) => {
                if (user.ID !== this.$gestios.profile.ID) {
                    const result = await this.$gestios.users.delete(user.ID)

                    if (!result.ok) pass = false
                } else {
                    this.$message.error('No puedes borrar tu propio usuario')
                }
            })

            if (pass) {
                this.$message.success('Usuario borrado correctamente')
            } else {
                this.$message.error('Algún usuario no pudo ser borrado')
            }

            this.select = []
        },
        // Change user status
        userStatus(items = [], status) {
            items.forEach(async (user) => {
                if (user.ID !== this.$gestios.profile.ID) {
                    this.$gestios.users.status({ id: user.ID, status })
                } else {
                    this.$message.error('No puedes cambiar el estado de tu propio usuario')
                }
            })
        },
    },
}
</script>

<style lang="scss" module>
.header {
    position: relative;
    height: 150px;
    overflow: hidden;
    background-color: $dark;

    .info {
        display: flex;
    }
}

.avatar {
    margin-top: -70px;
    padding-right: 10px;

    img {
        background: white;
        padding: 5px;
    }
}

.table {
    tr td:first-child {
        min-width: 120px;
    }

    tr td:last-child {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}

.dropdown button:first-child {
    background: transparent;
    color: white;
}

.dropdown button:last-child {
    background: rgba(255, 255, 255, 0.4);
    color: white;
}

.dropdown.dropdown-primary {
    button,
    button:hover,
    button:focus {
        border-color: $primary;
    }

    button,
    button:hover,
    button:focus {
        background: $primary;
        color: white;
    }
}

.dropdown.dropdown-warning {
    button,
    button:hover,
    button:focus {
        border-color: $warning;
    }

    button,
    button:hover,
    button:focus {
        background: $warning;
        color: white;
    }
}

.dropdown.dropdown-danger {
    button,
    button:hover,
    button:focus {
        border-color: $danger;
    }

    button,
    button:hover,
    button:focus {
        background: $danger;
        color: white;
    }
}

.table tbody tr:nth-of-type(odd) {
    background: #fff !important;
}

.table tbody tr:nth-of-type(even) {
    background: #f2f4f8 !important;
}

.badgeGroup {
    text-transform: uppercase;
    font-weight: bold;
}
</style>
